<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <!-- Data Peserta -->
  <CCardBody class="py-0">
    <CRow>
      <div class="col-sm-12 col-xl-12">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Pelatihan</label>
          <multiselect
            class="mulit-select"
            label="nama_pelatihan"
            placeholder="Pilih Pelatihan"
            :show-labels="false"
            required
            v-model="pelatihan"
            :options="dataPelatihan"
          >
            <template slot="option"  slot-scope="{ option }">{{ option.no_lapor ? option.no_lapor + ' - ' : '' }} {{ option.nama_pelatihan ? option.nama_pelatihan + ' - ' : '' }}</template>
          </multiselect>
        </div>
      </div>
      <div class="col-sm-12 col-xl-12 pt-2 text-right">
        <button class="btn btn-md btn-info" @click="resetFilter">Reset Filter</button>
        <button class="btn btn-success btn-md ml-3" @click="changePelatihan">
          Terapkan Filter
        </button>
      </div>
    </CRow>
    <br />
    <div class="col-sm-12 col-xl-4" style="margin-left: -19px;">
      <div class="form-group">
        <CInput
          label="Pencarian"
          placeholder="Cari Data .."
          v-model="searchPelatihan"
        />
      </div>
    </div>
  </CCardBody>
  <!-- End Data Peserta -->
</template>

<script>
import DataPesertaPelatihanLmsService from "@/services/pelatihan/data-peserta/data-peserta-lms.service";
export default {
  
  data() {
    return {
      pelatihan: '',
      dataPelatihan: [],
      idWorkshopPelatihan: '',
      searchPelatihan : ''
    };
  },

  mounted() {
    this.getPelatihan();
  },
  watch : {
    searchPelatihan : function(val) {
        this.$parent.cariData(val);
    }
  },
  methods: {
    customLabel ({ no_lapor, nama_pelatihan }) {
      return `${no_lapor} - ${nama_pelatihan}`
    },

    changePageSize(e) {
      this.$parent.changePageSize(e);
    },
    filterData() {
      this.$parent.filterData(this.formFilter);
    },

    resetFilter() {
      this.periode = "";
      this.sertifikasi = "";
      $("#filterStatusPembayaran").val("");
    },
    
    getPelatihan() {
      var vm = this;
      DataPesertaPelatihanLmsService.getPelatihan()
        .then((response) => {
          vm.dataPelatihan = response.data;
          
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    changePelatihan() {
      var value = {
        id_workshop_pelatihan : this.pelatihan.id_workshop_pelatihan,
      }
      this.$parent.changePelatihan(value);
    }

    
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
